import React from 'react';
import {
  Sidebar,
  SidebarNav,
  SidebarNavItem,
  SidebarControls,
  SidebarControlBtn,
  Grid,
  Row,
  Col,
  FormControl,
} from '@sketchpixy/rubix';
import { Link, withRouter } from 'react-router';

import { getProfile, checkRoles } from '../api/api';
import RoleType from '../routes/RoleGroup/Roles/RoleType';
import { routeUrl } from '../routes/routeUrl';
import ServiceType from '../constants/ServiceType';

@withRouter
export default class SidebarContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      photo: null,
      menu: [],
      roles: [],
    };
  }

  handleChange = (e) => {
    this._nav.search(e.target.value);
  };

  componentDidMount() {
    let accessToken = localStorage.getItem('access_token');

    if (this.props.location.query.access_token) {
      accessToken = this.props.location.query.access_token;
      localStorage.setItem('access_token', accessToken);
    }

    getProfile((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        const email = result.adminUser.adminUserEmail;
        const adminUserInfo = JSON.parse(result.adminUser.adminUserInfoJson);
        if (email.endsWith('@neofect.com')) {
          this.setState({
            name: email,
            photo: adminUserInfo ? adminUserInfo.picture : null,
          });
        } else {
          alert('No Permission.');
          localStorage.clear();
          this.props.router.push(routeUrl.login);
        }
      }
    });

    checkRoles((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        let roles = this.state.roles;
        result.roles.map(role => {
          roles.push({
            roleType: RoleType.enumValueOf(role.roleEnumKey),
            region: role.region,
          });
        });

        localStorage.setItem('roles', JSON.stringify(roles));
        this.setState({ roles });
      }
    });
  }

  render() {
    const menuVisibility = {
      dashboardMenuVisible: false,
      rapaelHomeMenuVisible: false,
      subscriptionMenuVisible: false,
      preSubscriptionMenuVisible: false,
      b2cProductListMenuVisible: false,
      b2cPatientListMenuVisible: false,
      clinicianPatientMappingMenuVisible: false,
      assetUploadMenuVisible: false,
      assetClinicMenuVisible: false,
      assetClinic2MenuVisible: false,
      assetHomeMenuVisible: false,
      assetComCogMenuVisible: false,
      assetComCogAdminMenuVisible: false,
      assetComCogPublicMenuVisible: false,

      assetSmartCoachMenuVisible: false,
      assetSmartCareMenuVisible: false,
      assetSmartTableMenuVisible: false,
      assetB1MenuVisible: false,
      assetB2MenuVisible: false,
      assetSmartBodyCheckerMenuVisible: false,

      apkUploadMenuVisible: false,
      apkClinic2MenuVisible: false,
      apkHomeMenuVisible: false,
      apkComCogMenuVisible: false,
      settingMenuVisible: false,
      adminMenuVisible: false,
      permissionsMenuVisible: false,
      releaseMgntMenuVisible: false,
      multilingualMenuVisible: false,
    };

    this.state.roles.map(role => {
      switch (role.roleType) {
        case RoleType.DASHBOARD_READ_ONLY:
          menuVisibility.dashboardMenuVisible = true;
          break;
        case RoleType.SUBSCRIPTION_READ_ONLY:
          menuVisibility.rapaelHomeMenuVisible = true;
          menuVisibility.subscriptionMenuVisible = true;
          break;
        case RoleType.B2C_PRODUCT_LIST:
        case RoleType.B2C_PRODUCT_LIST_READ_ONLY:
          menuVisibility.preSubscriptionMenuVisible = true;
          menuVisibility.rapaelHomeMenuVisible = true;
          menuVisibility.b2cProductListMenuVisible = true;
          break;
        case RoleType.B2C_PATIENT_LIST:
        case RoleType.B2C_PATIENT_LIST_READ_ONLY:
          menuVisibility.rapaelHomeMenuVisible = true;
          menuVisibility.b2cPatientListMenuVisible = true;
          break;
        case RoleType.CLINICIAN_PATIENT_MAPPING:
        case RoleType.CLINICIAN_PATIENT_MAPPING_READ_ONLY:
          menuVisibility.rapaelHomeMenuVisible = true;
          menuVisibility.clinicianPatientMappingMenuVisible = true;
          break;
        case RoleType.ASSET_CLINIC:
        case RoleType.ASSET_CLINIC_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetClinicMenuVisible = true;
          break;
        case RoleType.ASSET_CLINIC2:
        case RoleType.ASSET_CLINIC2_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetClinic2MenuVisible = true;
          break;
        case RoleType.ASSET_HOME:
        case RoleType.ASSET_HOME_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetHomeMenuVisible = true;
          break;
        case RoleType.ASSET_COMCOG:
        case RoleType.ASSET_COMCOG_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetComCogMenuVisible = true;
          break;
        case RoleType.ASSET_COMCOG_ADMIN:
        case RoleType.ASSET_COMCOG_ADMIN_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetComCogAdminMenuVisible = true;
          break;
        case RoleType.ASSET_COMCOG_PUBLIC:
        case RoleType.ASSET_COMCOG_PUBLIC_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetComCogPublicMenuVisible = true;
          break;
        case RoleType.ASSET_SMART_COACH:
        case RoleType.ASSET_SMART_COACH_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetSmartCoachMenuVisible = true;
          break;
        case RoleType.ASSET_SMART_CARE:
        case RoleType.ASSET_SMART_CARE_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetSmartCareMenuVisible = true;
          break;
        case RoleType.ASSET_SMART_TABLE:
        case RoleType.ASSET_SMART_TABLE_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetSmartTableMenuVisible = true;
          break;
        case RoleType.ASSET_B1:
        case RoleType.ASSET_B1_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetB1MenuVisible = true;
          break;
        case RoleType.ASSET_B2:
        case RoleType.ASSET_B2_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetB2MenuVisible = true;
          break;
        case RoleType.ASSET_SMART_BODY_CHECKER:
        case RoleType.ASSET_SMART_BODY_CHECKER_READ_ONLY:
          menuVisibility.assetUploadMenuVisible = true;
          menuVisibility.assetSmartBodyCheckerMenuVisible = true;
          break;
        case RoleType.APK_CLINIC2:
        case RoleType.APK_CLINIC2_READ_ONLY:
          menuVisibility.apkUploadMenuVisible = true;
          menuVisibility.apkClinic2MenuVisible = true;
          break;
        case RoleType.APK_HOME:
        case RoleType.APK_HOME_READ_ONLY:
          menuVisibility.apkUploadMenuVisible = true;
          menuVisibility.apkHomeMenuVisible = true;
          break;
        case RoleType.APK_COMCOG:
        case RoleType.APK_COMCOG_READ_ONLY:
          menuVisibility.apkUploadMenuVisible = true;
          menuVisibility.apkComCogMenuVisible = true;
          break;
        case RoleType.ADMIN_LIST:
        case RoleType.ADMIN_LIST_READ_ONLY:
          menuVisibility.settingMenuVisible = true;
          menuVisibility.adminMenuVisible = true;
          break;
        case RoleType.PERMISSIONS:
        case RoleType.PERMISSIONS_READ_ONLY:
          break;
        case RoleType.PERMISSION_GROUP:
        case RoleType.PERMISSION_GROUP_READ_ONLY:
          menuVisibility.settingMenuVisible = true;
          menuVisibility.permissionsMenuVisible = true;
          break;
        case RoleType.RELEASE_MGNT:
        case RoleType.RELEASE_MGNT_READ_ONLY:
          menuVisibility.releaseMgntMenuVisible = true;
          break;
        case RoleType.MULTILINGUAL_MGNT:
        case RoleType.MULTILINGUAL_MGNT_READ_ONLY:
          menuVisibility.multilingualMenuVisible = true;
          break;
        case RoleType.APK_CONTENTS:
        case RoleType.APK_CONTENTS_READ_ONLY:
          break;
      }
    });

    const dashboardMenu = [
      (
        <div
          key="dashboardHeader"
          className="sidebar-header"
          data-name="PREVIEW"
          hidden={!menuVisibility.dashboardMenuVisible}
        >
          PREVIEW
        </div>
      ), (
        <SidebarNavItem
          key="dashboard"
          glyph="icon-fontello-gauge"
          name="Dashboard"
          href={routeUrl.dashboard}
          hidden={!menuVisibility.dashboardMenuVisible}
        />
      ),
    ];

    const rapaelHomeMenu = (
      <div className="sidebar-header" data-name="Rapael Home" hidden={!menuVisibility.rapaelHomeMenuVisible}>
        Rapael Home
      </div>
    );

    const subscriptionStatusMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomeSubscriptionStatus}
        glyph="icon-stroke-gap-icons-Pulse float-right-rtl"
        name="Subscription Status"
        hidden={!menuVisibility.subscriptionMenuVisible}
      />
    );

    const preSubscriptionMenu = (
      <SidebarNavItem
        href={routeUrl.preSubscriptions}
        glyph="icon-stroke-gap-icons-Plaine float-right-rtl"
        name="Pre Subscription List"
        hidden={!menuVisibility.preSubscriptionMenuVisible}
      />
    );


    const paymentMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomePayment}
        glyph="icon-fontello-credit-card-1 float-right-rtl"
        name="Payment"
        hidden={!menuVisibility.b2cProductListMenuVisible}
      />
    );

    const paymentListMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomePaymentList}
        glyph="icon-fontello-credit-card-1 float-right-rtl"
        name="Payment List"
        hidden={!menuVisibility.b2cProductListMenuVisible}
      />
    );

    const calculatorMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomeCalculator}
        glyph="icon-stroke-gap-icons-Calculator float-right-rtl"
        name="Calculator"
        hidden={!menuVisibility.b2cProductListMenuVisible}
      />
    )

    const patientListMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomePatientsList}
        glyph="icon-stroke-gap-icons-Rolodex float-right-rtl"
        name="Patient List"
        hidden={!menuVisibility.b2cPatientListMenuVisible}
      />
    );

    const userListMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomeUserList}
        glyph="icon-stroke-gap-icons-Rolodex float-right-rtl"
        name="User List"
        hidden={!menuVisibility.b2cPatientListMenuVisible}
      />
    );


    const clinicianPatientMappingMenu = (
      <SidebarNavItem
        href={routeUrl.rapaelHomeCpMapping}
        glyph="icon-fontello-flow-merge float-right-rtl"
        name="Clinician - Patients"
        hidden={!menuVisibility.clinicianPatientMappingMenuVisible}
      />
    );

    const assetUploadMenu = [
      (
        <div
          key="assetUploadMenuHeader"
          className="sidebar-header"
          data-name="ASSET"
          hidden={!menuVisibility.assetUploadMenuVisible}
        >
          ASSET
        </div>
      ), (
        <SidebarNavItem
          key="assetUploadMenu"
          glyph="icon-feather-cloud-upload float-right-rtl"
          name="Upload"
          hidden={!menuVisibility.assetUploadMenuVisible}
        >
          <SidebarNav>
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Rapael Clinic"
              href={`${routeUrl.assetUpload}/${ServiceType.RAPAEL_CLINIC.name}`}
              hidden={!menuVisibility.assetClinicMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Rapael Clinic2"
              href={`${routeUrl.assetUpload}/${ServiceType.RAPAEL_CLINIC2.name}`}
              hidden={!menuVisibility.assetClinic2MenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Rapael Home"
              href={`${routeUrl.assetUpload}/${ServiceType.RAPAEL_HOME.name}`}
              hidden={!menuVisibility.assetHomeMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="ComCog"
              href={`${routeUrl.assetUpload}/${ServiceType.COMCOG.name}`}
              hidden={!menuVisibility.assetComCogMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="ComCog Admin"
              href={`${routeUrl.assetUpload}/${ServiceType.COMCOG_ADMIN.name}`}
              hidden={!menuVisibility.assetComCogAdminMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="ComCog Public"
              href={`${routeUrl.assetUpload}/${ServiceType.COMCOG_PUBLIC.name}`}
              hidden={!menuVisibility.assetComCogPublicMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Smart Coach"
              href={`${routeUrl.assetUpload}/${ServiceType.SMART_COACH.name}`}
              hidden={!menuVisibility.assetSmartCoachMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Smart Care"
              href={`${routeUrl.assetUpload}/${ServiceType.SMART_CARE.name}`}
              hidden={!menuVisibility.assetSmartCareMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Smart Table"
              href={`${routeUrl.assetUpload}/${ServiceType.SMART_TABLE.name}`}
              hidden={!menuVisibility.assetSmartTableMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="B1 Sling"
              href={`${routeUrl.assetUpload}/${ServiceType.B1.name}`}
              hidden={!menuVisibility.assetB1MenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="B2 Video Analysis"
              href={`${routeUrl.assetUpload}/${ServiceType.B2.name}`}
              hidden={!menuVisibility.assetB2MenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Smart Body Checker"
              href={`${routeUrl.assetUpload}/${ServiceType.SMART_BODY_CHECKER.name}`}
              hidden={!menuVisibility.assetSmartBodyCheckerMenuVisible}
            />
          </SidebarNav>
        </SidebarNavItem>
      ),
    ];

    const apkUploadMenu = [
      (
        <div
          key="apkUploadMenuHeader"
          className="sidebar-header"
          data-name="APK"
          hidden={!menuVisibility.apkUploadMenuVisible}
        >
          APK
        </div>
      ), (
        <SidebarNavItem
          key="apkUploadMenu"
          glyph="icon-feather-cloud-upload float-right-rtl"
          name="APK Upload"
          hidden={!menuVisibility.apkUploadMenuVisible}
        >
          <SidebarNav>
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Rapael Clinic2"
              href={`${routeUrl.apkUploadClient}/3`}
              hidden={!menuVisibility.apkClinic2MenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Rapael Home"
              href={`${routeUrl.apkUploadClient}/1`}
              hidden={!menuVisibility.apkHomeMenuVisible}
            />
            <SidebarNavItem
              glyph="icon-feather-upload"
              name="Contents"
              href={routeUrl.apkUploadContents}
              hidden={!menuVisibility.apkComCogMenuVisible}
            />
          </SidebarNav>
        </SidebarNavItem>
      ),
    ];

    const settingMenu = [
      (
        <div
          key="settingMenuHeader"
          className="sidebar-header"
          data-name="SETTINGS"
          hidden={!menuVisibility.settingMenuVisible}
        >
          SETTINGS
        </div>
      ), (
        <SidebarNavItem
          key="adminMenu"
          glyph="icon-stroke-gap-icons-Users"
          name="Admin User"
          href={routeUrl.adminUsers}
          hidden={!menuVisibility.adminMenuVisible}
        />
      ), (
        <SidebarNavItem
          key="roleMenu"
          glyph="icon-stroke-gap-icons-Layers"
          name="Role"
          href={routeUrl.adminRoles}
          hidden={!menuVisibility.permissionsMenuVisible}
        />
      ), (
        <SidebarNavItem
          key="roleGroupMenu"
          glyph="icon-stroke-gap-icons-Key"
          name="Role Groups"
          href={routeUrl.adminRoleGroups}
          hidden={!menuVisibility.permissionsMenuVisible}
        />
      ), (
        <SidebarNavItem
          key="multilingualMenu"
          glyph="icon-stroke-gap-icons-Message"
          name="Multilingual Mgnt"
          href={routeUrl.multilingualMgnt}
          hidden={!menuVisibility.multilingualMenuVisible}
        />
      ), (
        <SidebarNavItem
          key="releaseMgntMenu"
          glyph="icon-stroke-gap-icons-Tag"
          name="Release Mgnt"
          href={routeUrl.releaseMgnt}
          hidden={!menuVisibility.releaseMgntMenuVisible}
        />
      ),
    ];

    return (
      <div id="sidebar">
        <div id="avatar">
          <Grid>
            <Row className="fg-white">
              <Col xs={4} collapseRight>
                {
                  this.state.photo ? (
                    <img src={this.state.photo} width="40" height="40" />
                  ) : null
                }
              </Col>
              <Col xs={8} collapseLeft id="avatar-col">
                <div
                  style={{
                    top: 23,
                    fontSize: 16,
                    lineHeight: 1,
                    position: 'relative',
                    wordBreak: 'break-word',
                  }}
                >
                  {this.state.name}
                </div>
                <div>
                  <Link to={{ pathname: routeUrl.dashboard, query: { name: this.state.name } }}>
                  </Link>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        <SidebarControls>
          <SidebarControlBtn bundle="fontello" glyph="docs" sidebar={0} />
        </SidebarControls>
        <div id="sidebar-container">
          <Sidebar sidebar={0}>
            <div>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <FormControl
                      type="text"
                      placeholder="Search..."
                      onChange={this.handleChange}
                      className="sidebar-search"
                      style={{
                        border: 'none',
                        background: 'none',
                        margin: '10px 0 0 0',
                        borderBottom: '1px solid #666',
                        color: 'white',
                      }}
                    />
                    <div className="sidebar-nav-container">
                      <SidebarNav style={{ marginBottom: 0 }} ref={(c) => this._nav = c}>

                        {/* Dashboard */}
                        {dashboardMenu}

                        {/* RAPAEL Home*/}
                        {rapaelHomeMenu}
                        {subscriptionStatusMenu}

                        {/* Pre Subscription */}
                        {preSubscriptionMenu}

                        {paymentMenu}
                        {paymentListMenu}
                        {calculatorMenu}
                        {patientListMenu}
                        {userListMenu}
                        {clinicianPatientMappingMenu}

                        {/* Asset */}
                        {assetUploadMenu}

                        {/* APK */}
                        {/* APK Upload Menu 임시로 숨김 처리. 신규 기획 내용대로 구현 시 활성화 에정 */}
                        {/*{apkUploadMenu}*/}

                        {/* Setting */}
                        {settingMenu}

                      </SidebarNav>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </div>

          </Sidebar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/sidebar.js